<template>
    <div>
        <a-modal :visible="isVisible"
                :closable="false"
        >
            <template #footer>
                <a-button @click="handleBtnCancel" :disable="disabled">
                    Cancel
                </a-button>
                <a-button type="primary" @click="handleBtnUpdate" :loading="loading">
                    Update
                </a-button>
            </template>
            <div>
                <a-form-model> 
                    <a-row type="flex">
                        <a-col :span="24">
                            <a-form-model-item class="mb-10" 
											label="Parent Product"
                            >
							    <multiselect v-model="parent"
                                            label="itemName"
                                            :options="parentProducts"
                                >
                                    <template slot="singleLabel" slot-scope="{option}">
                                        {{ option.itemName }}
                                    </template>
                                </multiselect>
						    </a-form-model-item>
                        </a-col>
                        
                    </a-row>
                </a-form-model>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    data () {
        return  {
            isVisible : false,
            loading : false,
            disabled : false,
            category : '',
            productId : '',
            parent : null,
            parentProducts : []
        }
    },
    methods : {
        async handleBtnUpdate() {

            if(this.parent != null) {
                this.load();
                //console.log(this.parent.itemId);
                let payload = {
                    'itemId' : this.productId,
                    'parentId' : this.parent.itemId
                };
                //console.log(payload);
                await this.$store.dispatch('products/updateParentProduct', payload);
                this.reset();
            }
            
        },

        load() {
            this.loading = true;
            this.disabled = true;
        },

        reset() {
            this.loading = false,
            this.disabled = false,
            this.category = '',
            this.productId = '',
            this.parent = null,
            this.parentProducts = []
        },

        handleBtnCancel() {
            this.isVisible = false;
            this.reset();
        },
        
        showModal(product) {
            this.isVisible = true;
            this.productId = product.itemId;
            this.parentProducts = this.$store.getters['products/productsByCategoryId'](product.categoryId);
            //
            //remove child product
            //
            if (this.parentProducts.length > 1) {
                let index = this.parentProducts.findIndex(o => o.itemId === product.itemId );
                if(index > -1) {
                    this.parentProducts.splice(index, 1);
                }
            }
            
        },
        

    }
}
</script>

<style>

</style>